export function parseSegmentationFilter (filter) {
  if (!filter) return null
  if (typeof filter === 'object') return normalizeSegmentationFilter(filter)
  if (typeof filter === 'string') {
    try {
      return normalizeSegmentationFilter(JSON.parse(filter))
    } catch (e) {
      return { label: filter }
    }
  }
  return null
}

export function normalizeSegmentationFilter (obj) {
  if (!obj || typeof obj !== 'object') return obj
  // shallow clone to avoid mutating the original
  const parsed = { ...obj }

  const cct = parsed.concessionContractTariff
  // legacy format: concessionContractTariff was an id (number or numeric string)
  if (cct != null && typeof cct !== 'object') {
    const id = Number(cct)
    const label = typeof parsed.label === 'string' ? parsed.label : undefined
    const newCct = {}
    if (!Number.isNaN(id)) newCct.id = id
    if (label) newCct.label = label
    parsed.concessionContractTariff = newCct
    if (label) delete parsed.label
  }

  return parsed
}

export function escapeHtml (str) {
  if (str == null) return ''
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

// options: { gettextFn: function }
export function formatSegmentationFilterDisplay (filter, options = {}) {
  const parsed = parseSegmentationFilter(filter)
  if (!parsed) return ''
  const { gettextFn } = options

  try {
    const labels = []
    // top-level label
    if (parsed && typeof parsed === 'object') {
      if (typeof parsed.label === 'string') labels.push(escapeHtml(parsed.label))
      for (const [key, val] of Object.entries(parsed)) {
        if (val && typeof val === 'object' && typeof val.label === 'string') {
          const label = val.label
          if (String(key) !== 'concessionContractTariff') {
            const prefixText = (gettextFn && typeof gettextFn === 'function') ? gettextFn(String(key).toUpperCase()) : String(key).toUpperCase()
            labels.push(`<strong>${escapeHtml(prefixText)}:</strong> ${escapeHtml(label)}`)
          } else {
            labels.push(escapeHtml(label))
          }
        }
      }
    }

    if (labels.length) {
      return Array.from(new Set(labels)).join('<br>')
    }

    // fallback: include any string values (ignore numeric legacy values)
    const parts = Object.entries(parsed).map(([key, val]) => {
      if (val == null) return ''
      if (typeof val === 'string') {
        if (String(key) !== 'concessionContractTariff') {
          const prefixText = (gettextFn && typeof gettextFn === 'function') ? gettextFn(String(key).toUpperCase()) : String(key).toUpperCase()
          return `<strong>${escapeHtml(prefixText)}:</strong> ${escapeHtml(val)}`
        }
        return escapeHtml(val)
      }
      if (typeof val === 'object') {
        const label = val.label || val.name || ''
        if (label && String(key) !== 'concessionContractTariff') {
          const prefixText = (gettextFn && typeof gettextFn === 'function') ? gettextFn(String(key).toUpperCase()) : String(key).toUpperCase()
          return `<strong>${escapeHtml(prefixText)}:</strong> ${escapeHtml(label)}`
        }
        return escapeHtml(label)
      }
      return ''
    }).filter(Boolean)

    return parts.join('<br>')
  } catch (e) {
    return typeof filter === 'string' ? escapeHtml(filter) : escapeHtml(JSON.stringify(filter))
  }
}

export function formatSegmentationFilterTitle (filter) {
  const parsed = parseSegmentationFilter(filter)
  if (!parsed) return ''
  try {
    return JSON.stringify(parsed, null, 2)
  } catch (e) {
    return typeof filter === 'string' ? filter : String(filter)
  }
}
